import { TaggedError } from "@for-it/domain-lib";
export class BucketUnusableError extends TaggedError {
    constructor(bucketName) {
        super("BucketUnusableError", `Bucket '${bucketName}' is not accessible and could not be created`);
    }
}
